import { mbSize, Media } from '@foxrenderfarm/common'
import { Link } from 'gatsby'
import styled from 'styled-components'

export const SearchWrapper = styled.div<{ $background: string }>`
  width: 750px;
  height: 50px;
  border-radius: 100px;
  background: ${({ $background }) => $background};
  backdrop-filter: blur(112px);
  display: flex;
  align-items: center;
  padding: 0 40px;
  svg.close {
    cursor: pointer;
  }
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(670)};
    height: ${mbSize(76)};
    padding: 0 ${mbSize(60)};
    svg.search {
      width: ${mbSize(30)};
      height: ${mbSize(30)};
    }
  }
`

export const Input = styled.input`
  margin-left: 15px;
  background: transparent;
  border: none;
  font-family: MarkPro;
  font-size: 16px;
  color: #333333;
  flex: 1;
  &::placeholder {
    color: #666666;
  }
  ${Media.lessThan(Media.small)} {
    margin-left: ${mbSize(20)};
  }
`

export const InputDiv = styled.div`
  height: 20px;
  flex: 1;
  color: #666666;
  font-size: 16px;
  margin-left: 15px;
  cursor: text;
  ${Media.lessThan(Media.small)} {
    font-size: 16px;
    height: fit-content;
    margin-left: ${mbSize(20)};
  }
`

export const SearchModalWrapper = styled.div`
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  z-index: 9999999999;
  display: flex;
  justify-content: center;
`

export const SearchModalMask = styled.div`
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: rgba(0, 0, 0, 0.3);
  ${Media.lessThan(Media.small)} {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }
`

export const SearchModalContent = styled.div<{ $top: number; $left: number }>`
  position: absolute;
  top: ${({ $top }) => `${$top}px`};
  left: ${({ $left }) => `${$left}px`};
`

export const SearchResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 750px;
  height: 55vh;
  border-radius: 8px;
  background: #fff;
  margin-top: 5px;
  max-height: 750px;
  overflow: hidden;
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(670)};
    border-radius: ${mbSize(12)};
    margin-top: ${mbSize(8)};
    height: unset;
    max-height: 60vh;
  }
`

export const PaginationWrapper = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${Media.lessThan(Media.small)} {
    padding: ${mbSize(40)} 0;
  }
`

export const SearchResultItemsWrapper = styled.div`
  overflow: auto;
  flex: 1;
  ${Media.greaterThan(Media.small)} {
    &::-webkit-scrollbar {
      width: 16px;
      background: #fafafa;
      border-left: 1px solid #e8e8e8;
      border-right: 1px solid #e8e8e8;
    }
    &::-webkit-scrollbar-track {
      border-radius: 4px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border: 4px solid transparent;
      border-radius: 9px;
      background-clip: content-box;
    }
  }
`

export const SearchResultItem = styled(Link)`
  display: block;
  width: 100%;
  padding: 24px 30px;
  border-bottom: 1px solid #e8e8e8;
  transition: all 0.3s;
  cursor: pointer;
  &:hover {
    background: #fff4f1;
  }
  ${Media.lessThan(Media.small)} {
    border-bottom: unset;
    padding: ${mbSize(40)};
  }
`

export const SearchResultItemTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: #666666;
  margin: 12px 0 4px;
  strong {
    color: #f3512b;
  }
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(28)};
    margin: ${mbSize(24)} 0 ${mbSize(16)};
    color: #333333;
  }
`

export const SearchResultItemContent = styled.div`
  font-weight: 400;
  color: #444444;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  strong {
    color: #f3512b;
  }
  ${Media.lessThan(Media.small)} {
    -webkit-line-clamp: 4;
    font-size: ${mbSize(28)};
  }
`

export const SearchResultText = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  margin-bottom: 16px;
  span.value {
    font-weight: 700;
    color: #f3512b;
  }
  ${Media.lessThan(Media.small)} {
    color: #666666;
    font-size: ${mbSize(24)};
    padding: 0 ${mbSize(40)};
  }
`
